<template>
  <div class="col-12">
    <h3 class="border-bottom">{{ $t('eGiftCardBalanceCheck') }}</h3>

    <div class="d-flex col-md-6 col-sm-12 align-items-center m-auto pb-1 flex-wrap">
      <div class=" align-items-center">
        <label class="text-nowrap p-1"> {{ $t('eGiftCardCode') }}</label>
      </div>
      <WCInputGroup>
        <WCInput
          placeholder="E-Gift Card Code"
          id="giftcard-code__input"
          v-model="gcCode"
          :state="gc.status === 'inactive' || gc.status === 'invalid' ? 'invalid' : null"
          @keydown.enter="getGC()"
        />
        <template v-slot:right>
          <button type="submit" class="btn btn-primary btn-block" @click="getGC()">
            {{ $t('checkCard') }}
          </button>
        </template>
      </WCInputGroup>
    </div>
    <p
      class="text-danger text-center"
      v-if="(gc.status === 'inactive' || gc.status === 'invalid') && !loading"
      id="gift-card-balance-error__message"
    >
      {{ $t('cardEnteredInvalidInactive') }}
    </p>
    <div v-if="loading" class="wc-product-row__spinner-wrapper d-flex">
      <WCSpinner class="mx-auto align-self-center" size="xl" />
    </div>
    <WCGiftCard v-if="gc.status === 'active'" :gc="gc" />
  </div>
</template>
<script>
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCInputGroup from '@/modules/forms/components/WCInputGroup/WCInputGroup.vue';
import axios from 'axios';
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import WCGiftCard from '../components/WCGiftCard/WCGiftCard.vue';

export default {
  name: 'GiftCardCheck',
  components: { WCInput, WCInputGroup, WCGiftCard, WCSpinner },

  data() {
    return {
      loading: false,
      gcCode: '',
      gc: {},
    };
  },
  methods: {
    async getGC() {
      try {
        this.loading = true;
        const code = this.gcCode.toUpperCase();
        const response = await axios.get(`api/gc/${code}`);
        this.loading = false;
        this.gc = response.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
